import { useEffect, useState } from "react";
import { ResponsiveRadar } from "@nivo/radar";
import { CardTable } from "../../../../components/Card/CardTable";
import OverTimeCardsSection from "./OverTimeCardsSection";


const reasonNames = {
    pause: "Pausa",
    quality: "Calidad",
    provider: "Proveedor",
    quotation: "Cotización",
    negotiation: "Negociación",
    technical_difficulty: "Dificultad técnica",
    technical_knowledge: "Conocimiento técnico",
    management_monitoring: "Seguimiento gestión",
    missing_documentation: "Falta de documentación",
};

const OverTimeGraph = ({ year, listOfYears, updateYear, quantities, projects }) => {
    const [labelOffset, setLabelOffset] = useState({ offset: 0, marginY: 20, marginX: 81 });

    useEffect(() => {
        const updateLabelGraph = ({ target }) => {
            const { innerWidth } = target;
            setLabelOffset(innerWidth >= 768 ? { marginX: 130, marginY: 20, offset: 5 } : { offset: 10, marginY: 0, marginX: 90 });
        };
        window.addEventListener("resize", updateLabelGraph);
        updateLabelGraph({ target: window.innerWidth });
        return () => {
            window.removeEventListener("resize", updateLabelGraph);
        };
    }, []);

    return (
        <CardTable title="Análisis proyectos en rojo 2020" currentValue={year} listValues={listOfYears} updateValue={updateYear}>
            <div className="w-full h-full lg:flex lg:items-start lg:justify-center lg:gap-4  grow">
                <div className="w-full h-[258px] m-auto text-[8px] md:w-[497px] md:h-[350px] lg:m-0 lg:w-[500px] lg:h-[365px]   red-graph ">
                    <ResponsiveRadar
                        data={Object.entries(quantities).map(([_, reason]) => ({
                            reason: reasonNames[reason.title],
                            "Puntaje total": reason.totalScore,
                            projectos: reason.times,
                        }))}
                        keys={["Puntaje total", "projectos"]}
                        indexBy="reason"
                        maxValue={"auto"}
                        margin={{
                            top: labelOffset.marginY,
                            bottom: labelOffset.marginY,
                            right: labelOffset.marginX,
                            left: labelOffset.marginX,
                        }}
                        gridLabelOffset={labelOffset.offset}
                        dotBorderWidth={2}
                        valueFormat=">-.2f"
                        borderColor={{ from: "color" }}
                        dotSize={5}
                        dotColor={{ theme: "background" }}
                        colors={{ scheme: "nivo" }}
                        blendMode="multiply"
                        motionConfig="wobbly"
                        animate={true}
                    />
                </div>
                <div className=" h-fit pt-6 lg:pt-0">
                    <OverTimeCardsSection quantities={quantities} totalProjects={projects.length} />
                </div>
            </div>
        </CardTable>
    );
};

export default OverTimeGraph;
